import { hygraphClient } from '@/lib/graphql-clients';
import {
  getSdk,
  SpecialtyPage as HygraphSpecialtyPage,
  StaticSidebarComponentOptions,
} from '@/lib/types';

import { SpecialtyPage } from '@/features/specialty-page';
import specialtyPageTransformer from '@/features/specialty-page/hygraph/transformers/specialty-page.transformer';
import filterSidebarComponent from '@/features/specialty-page/utils/filter-sidebar-component.util';
import { orderBy } from '@/utils/array-utils';
import { routes } from '@/utils/route-utils';

type RelatedLink = {
  title: string;
  url: string;
};

export type RelatedLinksMap = Record<string, RelatedLink[]>;

const get = async (specialtyPage: SpecialtyPage): Promise<RelatedLinksMap> => {
  if (!specialtyPage.specialty?.discipline?.id) return {};
  const relatedLinksComponents = filterSidebarComponent(
    specialtyPage,
    StaticSidebarComponentOptions.RelatedLinks
  );

  if (!relatedLinksComponents) return {};

  const sdk = getSdk(hygraphClient(false));
  const { specialtyPages } = await sdk.SpecialtyPages({
    where: {
      specialty: {
        id_not: specialtyPage.specialty.id,
        discipline: {
          id: specialtyPage.specialty.discipline.id,
        },
      },
    },
  });

  return Object.fromEntries(
    relatedLinksComponents.map((c): [string, RelatedLink[]] => {
      return [
        c.id,
        orderBy(
          specialtyPages
            .map((hygraphSpecialtyPage) =>
              specialtyPageTransformer(
                hygraphSpecialtyPage as HygraphSpecialtyPage
              )
            )
            .map((specialtyPage) => ({
              title: specialtyPage.title || '',
              url: `/${routes.specialtyPage(specialtyPage)}`,
            })),
          (sp) => sp.title
        ),
      ];
    })
  );
};

const RelatedLinksService = {
  get,
};

export default RelatedLinksService;
